<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-09-27 17:05:47
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-20 10:37:14
-->
<template>
  <a-dropdown trigger="click" placement="bottomRight">
    <div class="user-info flex-v-c" @click.prevent>
      <span class="avatar flex-v-c">
        <span>{{ userInfo.name.substr(0, 1).toUpperCase() }}</span>
      </span>
      <div class="username overfl-oneline flex-v-c">
        <span>{{ userInfo.name }}</span>
        <svg-icon class="icon-arrow-right-1-fill" name="icon-arrow-right-1-fill"></svg-icon>
      </div>
    </div>
    <template #overlay>
      <a-menu>
        <div class="user-info-wrap flex-v-c">
          <span class="avatar flex-v-c">
            <span>{{ userInfo.name.substr(0, 1).toUpperCase() }}</span>
          </span>
          <span>
            <div class="username">{{ userInfo.name }}</div>
          </span>
        </div>
        <a-menu-divider />
        <a-menu-item key="0" @click="handleChangePwd">
          <svg-icon
            class="dropdown-icon"
            name="icon-lock-revise-line"
            color="rgba(68, 76, 89, 1)"
          />修改密码
        </a-menu-item>
        <a-menu-item key="1" @click="handleLogout">
          <svg-icon class="dropdown-icon" name="icon-logout-line" color="rgba(68, 76, 89, 1)" />退出
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { IUserInfo } from '@/store/types.d'
import { useStore } from 'vuex'
import { getStorageItem } from '@/utils/util'

export default defineComponent({
  props: {
    userInfo: {
      type: Object as PropType<IUserInfo>,
      default: () => {}
    }
  },
  emits: ['changePwd'],
  setup(props, context) {
    const { emit } = context
    const store = useStore()
    const handleLogout = () => {
      const userInfo = getStorageItem('userInfo')
      store.dispatch('user/logout', userInfo.userId)
    }
    const handleChangePwd = () => {
      emit('changePwd')
    }
    return {
      handleChangePwd,
      handleLogout
    }
  }
})
</script>

<style lang="less">
.user-info {
  height: 100%;
  margin-left: 24px;

  .avatar {
    width: 32px;
    height: 32px;
    // line-height: 40px;
    text-align: center;
    border-radius: 100%;
    background: #4d8eff;
    margin-right: 10px;
    color: #ffffff;
    position: relative;
    justify-content: center;
  }

  .username {
    height: 24px;
    line-height: 24px;
    max-width: 120px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    padding: 5px 8px;
    span {
      display: block;
      height: 14px;
      line-height: 14px;
    }
  }
}

.ant-dropdown-open {
  .username {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    color: #005bff;
  }
}

.ant-dropdown {
  width: 300px;
  ul {
    padding: 8px !important;
  }
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    height: 40px;
    line-height: 40px;
    padding: 0;
    padding-left: 10px;
  }
}

.user-info-wrap {
  height: 96px;
  .avatar {
    width: 64px;
    height: 64px;
    background: #4d8eff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    justify-content: center;
    font-weight: Regular;
    font-size: 28px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    margin-right: 16px;
  }
  .username {
    height: 16px;
    line-height: 16px;
    font-weight: Bold;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    letter-spacing: 0;
  }
}
</style>
